import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class CookieModuleService {
//
//   constructor() { }
// }

import * as JSCookie from 'js-cookie'; // /src/js.cookie';

// TODO: may be best to place this in a constants service
export const COOKIE_NAMES = {
  MANAGE_LIST_GRID_STATE: 'manage-list-grid-state',
  EXECECUTE_LIST_GRID_STATE: 'execute-list-grid-state',
  HOME_NAV_TOGGLE_STATE: 'homeNavToggleState',
};

type COOKIES =
  | 'manage-list-grid-state'
  | 'execute-list-grid-state'
  | 'homeNavToggleState';

@Injectable({
  providedIn: 'root',
})
export class CookieManagerService {
  constructor() {
    // 'ngInject';
  }

  static get defaultCookieAttributes() {
    // see defaults @ https://github.com/js-cookie/js-cookie
    return {
      secure: true,
      // expires
      // path
      // domain
    };
  }

  static get jsCookie() {
    return JSCookie;
  }

  setCookie(name: string, value: string | object, attributes = {}) {
    CookieManagerService.jsCookie.set(name, value);
  }

  getCookie(name: string) {
    return CookieManagerService.jsCookie.getJSON(name);
  }

  removeCookie(name: string) {
    CookieManagerService.jsCookie.remove(name);
  }
}
